module.exports = __webpack_public_path__ + "media/proksee-viewer/images/icon-viewer-bottom-5f3cb83bf43f00300299f45a8f115dbe.png";